import { createFileRoute } from "@tanstack/react-router";
import { MojFaqHub } from "@/components/MojFaqHub";
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";

const SITE = "https://nyclanguageinstitute.com";
const TITLE = "นักแปลกระทรวงยุติธรรม — คำถามที่พบบ่อย & 300 คีย์เวิร์ด | NYC";
const DESC = "รวม 300 คีย์เวิร์ด 8 คลัสเตอร์เรื่องนักแปล MoJ: คดีความ, นิติกรรม, การรับรอง, ราคา/ความเร็ว — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน";

export const Route = createFileRoute("/moj-translator/faq")({
  head: () => ({
    meta: [
      { title: ctaTitle(TITLE, "/moj-translator/faq", "th")},
      { name: "description", content: ctaDesc(DESC, "/moj-translator/faq", "th")},
      { property: "og:title", content: ctaTitle(TITLE, "/moj-translator/faq", "th")},
      { property: "og:description", content: ctaDesc(DESC, "/moj-translator/faq", "th")},
      { property: "og:url", content: `${SITE}/moj-translator/faq` },
      { property: "og:locale", content: "th_TH" },
    ],
    links: canonicalAndHreflang("/moj-translator/faq", "/en/moj-translator/faq"),
  }),
  component: () => <MojFaqHub lang="th" />,
});
